/* Shop the look + Complete the look: <look-buy>, size buttons for each piece
   and one button that adds every piece with a size picked. */
(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  };

  if (!customElements.get('look-buy')) customElements.define('look-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.btn = this.querySelector('[data-look-add]');
      this.err = this.querySelector('[data-look-error]');
      this.items = Array.from(this.querySelectorAll('[data-look-item]')).map((el) => {
        let variants = [];
        try { variants = JSON.parse(el.querySelector('[data-look-variants]').textContent); } catch (e) {}
        return { el, variants, groups: Array.from(el.querySelectorAll('[data-look-option]')), fixed: el.querySelector('[data-look-fixed]') };
      });
      this.items.forEach((it) => {
        it.el.addEventListener('change', (e) => {
          if (!e.target.matches('input[type="radio"]')) return;
          this.sync(it, e.target);
          this.update();
        });
      });
      if (this.btn) this.btn.addEventListener('click', () => this.add());
      this.update();
    }

    /* Picking a size on one piece fills the same size on pieces not yet chosen */
    sync(from, input) {
      if (this.items.length < 2 || from.groups.length !== 1) return;
      this.items.forEach((it) => {
        if (it === from || it.groups.length !== 1) return;
        if (it.groups[0].querySelector('input:checked')) return;
        const match = Array.from(it.groups[0].querySelectorAll('input')).find((i) => i.value === input.value && !i.disabled);
        if (match) match.checked = true;
      });
    }

    chosen(it) {
      if (it.fixed) return it.variants.find((v) => String(v.id) === it.fixed.value) || null;
      const picks = it.groups.map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
      if (picks.some((v) => v === null)) return null;
      return it.variants.find((v) => v.options.every((o, i) => o === picks[i])) || null;
    }

    update() {
      let cents = 0;
      let picked = 0;
      let blocked = false;
      this.items.forEach((it) => {
        // Sold-out sizes are struck through, for single-option pieces
        if (it.groups.length === 1) {
          it.groups[0].querySelectorAll('input').forEach((i) => {
            const v = it.variants.find((x) => x.options[0] === i.value);
            const off = !v || !v.available;
            i.disabled = off;
            if (off && i.checked) i.checked = false;
          });
        }
        it.groups.forEach((g) => {
          const c = g.querySelector('input:checked');
          const out = g.querySelector('[data-look-value]');
          if (out) out.textContent = c ? c.value : '';
        });
        const v = this.chosen(it);
        const full = it.groups.length > 1 && it.groups.every((g) => g.querySelector('input:checked'));
        if (full && (!v || !v.available)) blocked = true;
        // 3: price, and the struck-through price when on sale, follow the size
        const box = it.el.querySelector('[data-look-price] .price');
        if (v && box) {
          if (box.firstElementChild) box.firstElementChild.textContent = v.price_html;
          const sale = v.compare_at_price > v.price;
          let was = box.querySelector('.price__was');
          box.classList.toggle('price--sale', sale);
          if (sale) {
            if (!was) { was = document.createElement('s'); was.className = 'price__was'; box.appendChild(was); }
            was.textContent = v.compare_html;
            was.hidden = false;
          } else if (was) was.hidden = true;
        }
        it.el.classList.toggle('is-picked', !!(v && v.available));
        if (v && v.available) { cents += v.price; picked += 1; }
      });
      if (this.err && !this.busy) {
        if (blocked) { this.err.textContent = 'That combination is sold out. Please choose another.'; this.err.hidden = false; }
        else if (this.err.dataset.combo) this.err.hidden = true;
        this.err.dataset.combo = blocked ? '1' : '';
      }
      if (!this.btn || this.busy) return;
      const all = this.items.length;
      this.btn.disabled = picked === 0;
      const price = money(cents, this.dataset.currency);
      if (picked === 0) this.btn.textContent = all > 1 ? 'Choose your sizes' : 'Choose your size';
      else if (all > 1 && picked === all) this.btn.textContent = `${all === 2 ? 'Add both' : `Add all ${all}`} to cart \u00b7 ${price}`;
      else if (picked === 1) this.btn.textContent = `Add to cart \u00b7 ${price}`;
      else this.btn.textContent = `Add ${picked} to cart \u00b7 ${price}`;
    }

    async add() {
      if (this.busy) return;
      const items = this.items.map((it) => this.chosen(it)).filter((v) => v && v.available).map((v) => ({ id: v.id, quantity: 1 }));
      if (!items.length) return;
      this.busy = true;
      this.btn.disabled = true;
      this.btn.textContent = 'Adding\u2026';
      if (this.err) { this.err.hidden = true; this.err.dataset.combo = ''; }
      let ok = false;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Sorry, we could not add that to your cart. Please try again.');
        ok = true;
      } catch (e) {
        if (this.err) { this.err.textContent = navigator.onLine === false ? 'You appear to be offline. Please try again.' : e.message; this.err.hidden = false; }
      }
      if (ok) {
        this.btn.textContent = 'Added';
        this.dispatchEvent(new CustomEvent('look:added', { bubbles: true }));
        // The items are in the cart; a slow refresh must not look like a failure
        try { if (typeof window.refreshCart === 'function') await window.refreshCart(); } catch (e) {}
        try { if (typeof drawers !== 'undefined' && drawers.cart) drawers.cart.open(); } catch (e) {}
        await new Promise((r) => setTimeout(r, 1200));
      }
      this.busy = false;
      this.update();
    }
  });
})();
